import { LocationDetailForm } from "@/features/location/detail/LocationDetailForm";
import { useModal } from "@/features/modal/ModalStackManager";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { theme } from "@/styles/theme";
import DatetimeUtil from "@/utils/dateTimeUtil";
import styled from "@emotion/styled";
import { Space, Title } from "@mantine/core";
import { OperationsGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useTranslation } from "react-i18next";

export const DetailHeader = (params: { operationData: OperationsGet200ResponseRowsInner }) => {
  const {
    name,
    code,
    fromLocationCode,
    fromLocationName,
    toLocationCode,
    toLocationName,
    siteCode,
    createdAt,
    creatorUserCode,
  } = params.operationData || {};

  const { openModal } = useModal();
  const { t } = useTranslation();

  return (
    <Container>
      <Title>
        {name} ({code})
      </Title>
      <Space h="md" />
      <ContentField>
        <Label>{t("site.code")}</Label>
        <Content>{siteCode}</Content>
      </ContentField>
      <ContentField>
        <Label>{t("operation.code")}</Label>
        <Content>{code}</Content>
      </ContentField>
      <ContentField>
        <Label>{t("operation.fromLocationCode")}</Label>
        <Content>
          <DetailLink
            onClick={() =>
              openModal(<LocationDetailForm locationCode={fromLocationCode} />, null, "")
            }
          >
            {fromLocationCode}
          </DetailLink>
        </Content>
      </ContentField>
      <ContentField>
        <Label>{t("operation.fromLocationName")}</Label>
        <Content>{fromLocationName}</Content>
      </ContentField>
      <ContentField>
        <Label>{t("operation.toLocationCode")}</Label>
        <Content>
          <DetailLink
            onClick={() =>
              openModal(<LocationDetailForm locationCode={toLocationCode} />, null, "")
            }
          >
            {toLocationCode}
          </DetailLink>
        </Content>
      </ContentField>
      <ContentField>
        <Label>{t("operation.toLocationName")}</Label>
        <Content>{toLocationName}</Content>
      </ContentField>
      <ContentField>
        <Label>
          {t("user.creatorUserCode")} ({t("user.created")})
        </Label>
        <Content>
          {creatorUserCode} ({createdAt ? DatetimeUtil(createdAt) : ""})
        </Content>
      </ContentField>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 16px 32px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  background: ${theme.colors?.gray?.[0]};
`;

const ContentField = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 23px;
  align-self: stretch;
`;

const Label = styled.label`
  display: flex;
  width: 160px;
  padding: 2px 0px;
  flex-direction: column;
  align-items: flex-start;
  white-space: pre-wrap;
`;

const Content = styled.span`
  display: flex;
  padding: 2px 0px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;
